import gql from "graphql-tag";
const getEntityDB_RegulatoryTax = gql(`
query MyQuery {
  EntityDB_RegulatoryTax {
    ADVFiler
    ADVStatus
    AIFMDReg1
    AIFMDReg2
    AIFMDReg3
    AIFMDReg4
    AddRegCountry
    AddRegDate
    AddRegNum
    AltTaxID
    AnnRptDueDate
    CFTCFiledDate
    CFTCNoAction
    CIKNum
    CIMACancelDate
    CIMANumber
    CIMARegDate
    CommodityPool
    Country
    DITCCancelDate
    DITCRegDate
    ERISAPlan
    EntityStatus
    FATCACancelDate
    FATCARegDate
    FFARegNum
    FinraCRDNum
    FundFamily
    GIIN
    ICAExempt
    LEINumber
    LargeTraderID
    PFFiler
    Purpose
    QuickRef
    SECFormDNum
    SECPrivFundID
    column_8832ElectClass
    column_8832ElectDate
    CompanyName
    } 
}`)
export default getEntityDB_RegulatoryTax;
